<template>
  <FilterLayout title="Clinical Criteria" :options="options" middle :selectedText="selectedText" @clear="$emit('input', [])">
    <div class="hvh-flex column">
      <div class="hvh-flex space-between toggle-all no-wrap">
        <div class="clickable" @click="selectAll">SELECT ALL</div>
        <div class="clickable ml-5" @click="$emit('input', [])">DESELECT ALL</div>
      </div>
      <v-text-field class="my-3" v-model="searchText" label="Search Clinical Criteria" prepend-inner-icon="mdi-magnify" :hideDetails="true" outline />
      <div class="options-box">
        <ClinicalCriteriaFilterGroup :group="group" :value="value" @input="emitData" v-for="group in filteredOptions" :key="group.key" />
      </div>
    </div>
  </FilterLayout>
</template>

<script>
import ClinicalCriteriaFilterGroup from './ClinicalCriteriaFilterGroup.vue';
import FilterLayout from './FilterLayout.vue';
import cloneDeep from 'clone-deep';
import { topEventTypes } from '../../../../libraries/liveFilters';
import axios from '../../../../axios';
import { errorDebug, hashCode } from '../../../../libraries/common';
export default {
  components: { FilterLayout, ClinicalCriteriaFilterGroup },
  props: ['value', 'filters'],
  data() {
    return {
      options: null,
      showOptions: true,
      searchText: null,
    };
  },
  computed: {
    filteredOptions() {
      var eventToTypes = topEventTypes();
      var typeToEvent = Object.keys(eventToTypes)
        .flatMap(key => eventToTypes[key].map(f => [key, f]))
        .reduce((acc, f) => { acc[f[1]] = f[0]; return acc; }, {});
      var updatedOptions= (this.options || [])
        .filter(f => !this.searchText || f.item.label.toLowerCase().includes(this.searchText.toLowerCase()))
        .groupBy(f => typeToEvent[f.item.type.toLowerCase()]);
        updatedOptions.forEach(s=>
        {
          if(s.key=="diagnoses"|| s.key=="procedures") 
          s.items=s.items.sortBy(t=>t.item.id.split("_")[1])
          else
          s.items=s.items.sortBy(t=>t.item.label);
    });

        return updatedOptions;
    },
    selectedText() {
      if (!(this.value || []).any()) return '';
      return `${this.value.first().procLabelRep||this.value.first().label} ${this.value.length > 1 ? `+${this.value.length - 1}` : ''}`.trim();
    },
    filterHashCode() {
      return hashCode(this.filters);
    },
  },
  methods: {
    selectAll() {
      this.$emit('input', cloneDeep(this.options.map(f => f.item)));
    },
    emitData(event) {
      this.$emit('input', event.sortBy(f => this.options.findIndex(g => g.item.label === f.label && g.item.type === f.type)));
    },
    getFilterOptions() {
        axios.post('/Analytics/Cohorts/ClinicalCriteriaFilterOptions', this.filters)
        .then(response => 
        {
    this.options=response.data; 
    this.options.forEach(s=>{
      if(s.item.type==="procDescrip")
      { 
        let indexStart=s.item.label.lastIndexOf('(');  
        s.item.procLabelRep=s.item.label.slice(indexStart).concat(s.item.label.slice(0,indexStart));}}); 
        })
        .catch(errorDebug)
       },
  },
  watch: {
    filterHashCode() {
      this.getFilterOptions();
    },
  },
  mounted() {
    this.getFilterOptions();
   },
}
</script>

<style lang="scss" scoped>
.toggle-all {
  color: #002f6c;
  font-size: 12px;
  font-weight: 500;
}

.options-box {
  overflow: auto;
  max-height: 200px;
}
</style>